import React from 'react';
import { FaSun, FaClock, FaUserFriends, FaHeart, FaWhatsapp, FaCheckCircle, FaHome, FaPuzzlePiece } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const gtag_report_conversion = (url) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-16956303663/FXqBCP_4gNcaEK_SspU_',
      'event_callback': function () {
        if (typeof(url) !== 'undefined') {
          window.location = url;
        }
      }
    });
  } else {
    window.location = url;
  }
};

const CD = () => {
  const servicios = [
    {
      icon: <FaClock />,
      title: "Jornada Simple o Completa",
      description: "Horarios flexibles de 8 a 16 hs adaptados a las necesidades familiares"
    },
    {
      icon: <FaUserFriends />,
      title: "Actividades Grupales",
      description: "Talleres de arte, música, cocina y actividades recreativas"
    },
    {
      icon: <FaHeart />,
      title: "Atención Personalizada",
      description: "Planes individuales según las capacidades de cada concurrente"
    },
    {
      icon: <FaPuzzlePiece />,
      title: "Terapias Integradas",
      description: "Psicología, fonoaudiología, terapia ocupacional incluidas"
    },
    {
      icon: <FaHome />,
      title: "Ambiente Familiar",
      description: "Espacios cálidos y seguros que promueven el bienestar"
    },
    {
      icon: <FaSun />,
      title: "Vida Social Activa",
      description: "Salidas recreativas y participación en eventos comunitarios"
    }
  ];

  const rutinaDiaria = [
    { hora: "8:00 - 9:00", actividad: "Recepción y desayuno" },
    { hora: "9:00 - 10:30", actividad: "Terapias individuales" },
    { hora: "10:30 - 11:00", actividad: "Actividades en sala" },
    { hora: "11:00 - 12:30", actividad: "Talleres grupales" },
    { hora: "12:30 - 13:30", actividad: "Almuerzo" },
    { hora: "13:30 - 15:00", actividad: "Actividades recreativas" },
    { hora: "15:00 - 15:30", actividad: "Merienda" },
    { hora: "15:30 - 16:00", actividad: "Preparación para salida" }
  ];

  return (
    <div className="container">
      {/* Header optimizado para SEO */}
      <div className="sede-header">
        <h1>Centro de Día en Zona Sur</h1>
        <p>Atención integral diurna para jóvenes y adultos con discapacidad intelectual en Temperley y Glew. 
          <strong> Aceptamos todas las obras sociales.</strong></p>
      </div>

      {/* Introducción */}
      <section className="sede-info">
        <div className="sede-details">
          <h2>¿Qué es un Centro de Día?</h2>
          <p>
            Un <strong>Centro de Día (CD)</strong> es un servicio especializado que brinda atención integral durante 
            el día a <strong>personas con discapacidad intelectual</strong>, promoviendo su desarrollo personal, 
            social y ocupacional.
          </p>
          <p>
            En <strong>Mi Lugar Centro de Día</strong>, ofrecemos un espacio de contención y crecimiento donde 
            cada persona puede desarrollar sus habilidades, mantener una rutina estructurada y participar 
            activamente en la comunidad.
          </p>
          <div className="sede-buttons" style={{ marginTop: '20px' }}>
            <a
              href="#"
              className="btn btn-whatsapp"
              onClick={(e) => {
                e.preventDefault();
                gtag_report_conversion("https://wa.me/5491165651675");
              }}
            >
              <FaWhatsapp /> Consultar disponibilidad
            </a>
          </div>
        </div>
        <div className="sede-image">
          <img 
            src="https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca" 
            alt="Centro de Día - Atención diurna para personas con discapacidad intelectual"
          />
        </div>
      </section>

      {/* Servicios */}
      <section className="sede-facilities">
        <h2 className="section-title">Servicios de Nuestro Centro de Día</h2>
        <div className="facilities-grid">
          {servicios.map((servicio, index) => (
            <div key={index} className="facility-item">
              <div className="facility-icon">{servicio.icon}</div>
              <div>
                <h3>{servicio.title}</h3>
                <p>{servicio.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Rutina diaria */}
      <section className="sede-facilities">
        <h2 className="section-title">Un Día en Nuestro Centro de Día</h2>
        <p>
          Mantenemos una rutina estructurada que brinda seguridad y predictibilidad, 
          fundamental para el bienestar de las personas con discapacidad.
        </p>
        <div className="facilities-grid">
          {rutinaDiaria.map((item, index) => (
            <div key={index} className="facility-item">
              <FaClock className="facility-icon" />
              <div>
                <h3>{item.hora}</h3>
                <p>{item.actividad}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Beneficios */}
      <section className="sede-facilities">
        <h2 className="section-title">Beneficios</h2>
        <div className="facilities-grid">
          <div className="facility-item">
            <FaCheckCircle className="facility-icon" />
            <div>
              <h3>Para el Concurrente</h3>
              <ul>
                <li>Desarrollo de autonomía personal</li>
                <li>Socialización con pares</li>
                <li>Rutina estructurada y predecible</li>
                <li>Estimulación cognitiva continua</li>
                <li>Participación en actividades significativas</li>
              </ul>
            </div>
          </div>
          <div className="facility-item">
            <FaCheckCircle className="facility-icon" />
            <div>
              <h3>Para la Familia</h3>
              <ul>
                <li>Asistencia en las necesidades familiares</li>
                <li>Apoyo profesional especializado</li>
                <li>Orientación y contención familiar</li>
                <li>Tranquilidad de atención profesional</li>
                <li>Red de apoyo con otras familias</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Población objetivo */}
      <section className="sede-facilities">
        <h2 className="section-title">¿Quiénes pueden asistir a nuestro Centro de Día?</h2>
        <div className="facilities-grid">
          <div className="facility-item">
            <FaCheckCircle className="facility-icon" />
            <div>
              <h3>Población Objetivo</h3>
              <p>
                Nuestro <strong>Centro de Día en zona sur</strong> está dirigido a jóvenes y adultos a partir 
                de los 6 años con:
              </p>
              <ul>
                <li>Discapacidad intelectual leve, moderada o severa</li>
                <li>Síndrome de Down</li>
                <li>Trastornos del espectro autista (TEA)</li>
                <li>Parálisis cerebral</li>
                <li>Discapacidades múltiples</li>
                <li>Otras condiciones que requieran apoyo especializado</li>
              </ul>
            </div>
          </div>
          <div className="facility-item">
            <FaCheckCircle className="facility-icon" />
            <div>
              <h3>Proceso de Admisión</h3>
              <ol>
                <li>Entrevista inicial con la familia</li>
                <li>Evaluación interdisciplinaria</li>
                <li>Período de adaptación gradual</li>
                <li>Elaboración del plan individual</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      {/* Obras sociales */}
      <section className="sede-facilities">
        <h2 className="section-title">Centro de Día con Cobertura de Obras Sociales</h2>
        <p>
          Trabajamos con todas las obras sociales y prepagas. Nuestro equipo administrativo 
          gestiona las autorizaciones necesarias para facilitar el acceso al servicio.
        </p>
        <div className="facilities-grid">
          <div className="facility-item">
            <FaCheckCircle className="facility-icon" />
            <div>
              <h3>Obras Sociales que cubren Centro de Día:</h3>
              <ul>
                <li>IOMA</li>
                <li>PAMI (para mayores de 65 años)</li>
                <li>OSDE</li>
                <li>Swiss Medical</li>
                <li>PROFE</li>
                <li>Obra Social Ciudad de Buenos Aires</li>
                <li>Y muchas más...</li>
              </ul>
            </div>
          </div>
          <div className="facility-item">
            <FaCheckCircle className="facility-icon" />
            <div>
              <h3>Documentación necesaria:</h3>
              <ul>
                <li>Certificado de discapacidad (CUD)</li>
                <li>Prescripción médica</li>
                <li>DNI del beneficiario</li>
                <li>Carnet de obra social</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Ubicaciones */}
      <section className="sede-facilities">
        <h2 className="section-title">Nuestros Centros de Día en Zona Sur</h2>
        <div className="facilities-grid">
          <div className="facility-item">
            <FaCheckCircle className="facility-icon" />
            <div>
              <h3>CD Temperley</h3>
              <p><strong>Dirección:</strong> A. Gallardo 646, Temperley</p>
              <p><strong>Teléfono:</strong> 11 6565-1675</p>
              <p>Cerca de Lomas de Zamora, Banfield y Lanús</p>
              <div style={{ marginTop: '10px' }}>
                <Link to="/temperley" className="btn btn-small">Conocer sede</Link>
              </div>
            </div>
          </div>
          <div className="facility-item">
            <FaCheckCircle className="facility-icon" />
            <div>
              <h3>CD Glew</h3>
              <p><strong>Dirección:</strong> RP210 Nº 22548, Glew</p>
              <p><strong>Teléfono:</strong> 11 6566-1677</p>
              <p>Accesible desde Longchamps, Burzaco y alrededores</p>
              <div style={{ marginTop: '10px' }}>
                <Link to="/glew" className="btn btn-small">Conocer sede</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Float Button */}
      <a
        href="#"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          e.preventDefault();
          gtag_report_conversion("https://wa.me/5491165651675");
        }}
      >
        <FaWhatsapp />
      </a>

    </div>
  );
};

export default CD;